/*
  Swaps a product's first gallery image for a 3D model of its cut-out
  (snippets/product-3d-button.liquid). Uses Shopify's hosted <model-viewer>, loaded only on
  the first click: drag to turn, pinch/scroll to zoom, AR on phones (GLB for Android,
  USDZ for iPhone).
*/
(() => {
  let viewerReady;
  const loadViewer = () =>
    (viewerReady ||= new Promise((resolve) => {
      if (customElements.get('model-viewer')) return resolve();
      Shopify.loadFeatures([{ name: 'model-viewer', version: '1.12', onLoad: () => customElements.whenDefined('model-viewer').then(resolve) }]);
    }));

  document.addEventListener('click', async (event) => {
    const open = event.target.closest('[data-product-3d]');
    const close = event.target.closest('[data-product-3d-close]');

    if (close) {
      close.closest('.product-3d').remove();
      return;
    }
    if (!open) return;

    const slide = open.closest('.product__media-item');
    if (slide.querySelector('.product-3d')) return;

    const stage = document.createElement('div');
    stage.className = 'product-3d';
    stage.innerHTML = `
      <model-viewer
        src="${open.dataset.glb}"
        ios-src="${open.dataset.usdz}"
        alt="${open.dataset.alt}"
        camera-controls
        auto-rotate
        auto-rotate-delay="1500"
        rotation-per-second="20deg"
        ar
        ar-modes="webxr scene-viewer quick-look"
        shadow-intensity="1"
        exposure="1.1"
        interaction-prompt="none"
        touch-action="pan-y"
      ></model-viewer>
      <button type="button" class="product-3d__close" data-product-3d-close aria-label="Close 3D view">&times;</button>`;
    slide.appendChild(stage);
    await loadViewer();
  });
})();
